import React from "react";
import "./Intermediaries.css";

import Header from "../../components/Header/Header";
import Footer from "../../components/Footer/Footer";

import benefitsIcon from "../../assets/images/Group 1000001128@2x.png";

import curveVector from "../../assets/images/Vector 335.svg";

import solutionImg from "../../assets/images/cuate@2x.png";

import approvalIcon from "../../assets/images/Approval.png";

import appScreen1 from "../../assets/images/1@2x.png";
import appScreen2 from "../../assets/images/Group 39479@2x.png";

import appScreen3 from "../../assets/images/m3@2x.png";
import appScreen4 from "../../assets/images/m4@2x.png";

import appScreen5 from "../../assets/images/m12@2x.png";
import appScreen6 from "../../assets/images/m5@2x.png";

import vector21 from "../../assets/images/Vector 21@2x.png";

import playStoreBadge from "../../assets/images/Group.svg";

const Intermediaries: React.FC = () => {
  return (
    <>

<title>Premium Financing Solutions for Intermediaries</title>
<meta
  name="description"
  content="Enable customers to pay insurance premiums through flexible EMIs. Finsall empowers intermediaries with fast approvals, digital workflow and better conversions."
/>

      <Header />

      <main className="intermediaries-page">

        {/* HERO CARD */}

        <section className="intermediaries-page-section">

          <div className="intermediaries-hero-card">

            <h1>
              Premium Financing Solutions for Intermediaries
            </h1>

            <p>
              We enable intermediaries to insure under-insured and
              un-insured customers by making insurance more affordable
            </p>

            <div className="intermediaries-video-wrapper">

              <iframe
  width="100%"
  height="100%"
  src="https://www.youtube.com/embed/uvWBGnvVJqQ"
  title="YouTube video player"
  frameBorder="0"
  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
  allowFullScreen
></iframe>

            </div>

          </div>

        {/* </section> */}

{/* Benefits section */}

     {/* <section className="benefits-section"> */}
  <div className="benefits-wrapper">

    <h2 className="benefits-title">
      How can you benefit?
    </h2>

    <div className="benefit-intro">
      <p>
        Finsall will help improve your chance of a successful sale.
      </p>

      <p>
        There are several leading insurance intermediaries who have already
        started offering premium financing to customers.
      </p>
    </div>

    <img
      src={curveVector}
      alt=""
      className="benefits-curve"
    />

    <img src={benefitsIcon} alt="" className="benefit-icon icon-1" />
    <img src={benefitsIcon} alt="" className="benefit-icon icon-2" />
    <img src={benefitsIcon} alt="" className="benefit-icon icon-3" />

    <div className="benefit-card benefit-card-1">
      <p>
        Ability to conclude a <strong>sale increases multi-fold.</strong>
        Insureds are comfortable in
        <strong> opting for higher ticket size.</strong>
      </p>
    </div>

    <div className="benefit-card benefit-card-2">
      <p>
        Spike in <strong>renewals and retention</strong> of customers.
        Increase chance of <strong>cross-selling.</strong>
      </p>
    </div>

    <div className="benefit-card benefit-card-3">
      <p>
        Proprietary risk profiling leads to
        <strong> lower morale hazard and frauds.</strong>
        Leading to <strong>profitable portfolios.</strong>
      </p>
    </div>

  </div>
{/* </section> */}

        {/* SOLUTION SECTION */}

        {/* <section className="solution-section"> */}

          <div className="solution-card">

            <div className="solution-left">

              <img
    src={solutionImg}
    alt="illustration of user calculating insurance emi on finsall app"
    className="solution-image desktop-only"
  />


            </div>

            <div className="solution-right">

              <h2>
                Solution for insurance intermediaries
              </h2>

              {/* Mobile image */}
  <img
    src={solutionImg}
    alt="illustration of user calculating insurance emi on finsall app"
    className="solution-image mobile-only"
  />

              <div className="solution-list">

                <div className="solution-item">

                  <img
  src={approvalIcon}
  alt="feature icon for removing budget constraints"
  className="solution-icon-img"
/>

                  <div>

                    <h4>
                      Removing budget constraints for the customer
                    </h4>

                    <p>
                      Enables customer to buy or buy adequately.
                      Proven to increase sales.
                    </p>

                  </div>

                </div>

                <div className="solution-item">

                  <img
  src={approvalIcon}
  alt="feature icon for paperless process"
  className="solution-icon-img"
/>

                  <div>

                    <h4>
                      Paperless process
                    </h4>

                    <p>
                      No need for any physical documents /
                      signature / interaction.
                    </p>

                  </div>

                </div>

                <div className="solution-item">

                  <img
  src={approvalIcon}
  alt="feature icon for emi calculator"
  className="solution-icon-img"
/>

                  <div>

                    <h4>
                      Easy EMI calculator
                    </h4>

                    <p>
                      Provide quick estimates on the interest
                      amount and processing fees to customers
                      on the go.
                    </p>

                  </div>

                </div>

                <div className="solution-item">

                  <img
  src={approvalIcon}
  alt="feature icon for quick approvals"
  className="solution-icon-img"
/>

                  <div>

                    <h4>
                      Quick Approvals
                    </h4>

                    <p>
                      Lightening fast approvals power a
                      great customer and intermediary experience.
                    </p>

                  </div>

                </div>

                <div className="solution-item">

                <img
  src={approvalIcon}
  alt="feature icon for on call support"
  className="solution-icon-img"
/>
                  <div>

                    <h4>
                      On-call support
                    </h4>

                    <p>
                      Experts are just a call away to support
                      customers and intermediaries.
                    </p>

                  </div>

                </div>

                <div className="solution-item">

                  <img
  src={approvalIcon}
  alt="feature icon for differentiated offering"
  className="solution-icon-img"
/>

                  <div>

                    <h4>
                      Differentiated offering
                    </h4>

                    <p>
                      Be the market leader by offering market
                      leading solutions.
                    </p>

                  </div>

                </div>

              </div>

              <a
                href="https://play.google.com"
                target="_blank"
                rel="noreferrer"
                className="playstore-btn"
              >
                <img
  src={playStoreBadge}
  alt="google play download button for intermediary app"
/>
              </a>

            </div>

          </div>

        </section>

        {/* APP SECTION */}

        <section className="app-section">

          <div className="app-card">

            <h2>
              App for Insurance Intermediaries
            </h2>

                        {/* ROW 1 */}

            <div className="app-row">

              <div className="app-phone">
                <img
                  src={appScreen1}
                  alt="mobile screen showing insurance emi calculator on finsall app"
                />
              </div>

              <div className="app-content">

                <p>
                  Get an instant and transparent quote with upfront
                  payment, interest rate, interest amount, EMI amount
                  and other details. No hidden charges!
                </p>

                <img
                  src={vector21}
                  alt="Arrow"
                  className="app-arrow"
                />

              </div>

              <div className="app-phone">
                <img
                  src={appScreen2}
                  alt="mobile screen showing insurance emi quotation on finsall app"
                />
              </div>

            </div>

            {/* ROW 2 */}

            <div className="app-row">

              <div className="app-phone">
                <img
                  src={appScreen3}
                  alt="mobile screen showing customer status and verification steps on finsall app"
                />
              </div>

              <div className="app-content">

                <h3>Paperless Documentation</h3>

                <p>
                  Minimum requirements for approval and
                  processing without any requirement of
                  physical presence.
                </p>

                <h3>Customer Approval</h3>

                <p>
                  Add a new customer in 3 easy steps and
                  get real-time updates on the
                  "My Customers" section.
                </p>

                <h3>Insurance EMI Approval</h3>

                <p>
                  Keep real-time track of customer’s
                  application in the
                  "My Application" section.
                </p>

              </div>

              <div className="app-phone">
                <img
                  src={appScreen4}
                  alt="mobile screen showing insurance application progress on finsall app"
                />
              </div>

            </div>

            {/* ROW 3 */}

            <div className="app-row">

              <div className="app-phone">
                <img
                  src={appScreen5}
                  alt="mobile screen showing customer application list on finsall app"
                />
              </div>

              <div className="app-content">

                <h3>Application Details</h3>

                <p>
                  Get details of all your customers and
                  their applications with a single click.
                </p>

                <ul className="app-feature-list">

                  <li>
                    Ability to share links with customers,
                    if required
                  </li>

                  <li>
                    Guide customers remotely based on
                    progress
                  </li>

                  <li>
                    Instant help from Finsall support
                  </li>

                </ul>

                <img
                  src={vector21}
                  alt="Arrow"
                  className="app-arrow"
                />

              </div>

              <div className="app-phone">
                <img
                  src={appScreen6}
                  alt="mobile screen showing detailed insurance application information on finsall app"
                />
              </div>

            </div>

          </div>

        </section>

        {/* TRAINING CTA */}

        <section className="training-section">

          <div className="training-card">

            <div>

              <h2>
                Schedule a Training Session
              </h2>

              <p>
                Please connect with our premium financing
                specialists
              </p>

            </div>

            <button className="trng-btn"
                      onClick={() =>
              window.location.href = "/contact-us"
            }>
                        Get in Touch
                      </button>

          </div>

        </section>

      </main>

      <Footer />

    </>
  );
};

export default Intermediaries;